import { render, staticRenderFns } from "./vs-form-wrapper.vue?vue&type=template&id=2e44d7c7&scoped=true"
import script from "./vs-form-wrapper.vue?vue&type=script&lang=js"
export * from "./vs-form-wrapper.vue?vue&type=script&lang=js"
import style0 from "./vs-form-wrapper.vue?vue&type=style&index=0&id=2e44d7c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44d7c7",
  null
  
)

export default component.exports